import { CodeDepartment, CodeStatus, PermitCategory, PermitType } from "../common/enums";
import Position, { Position_normalize } from "./Position";
import { MaritimeEventType } from "../common/enums";

type BaseWorkPermitInfo = {
    id: number;
    documentReferenceId: string;
    sequenceIdentifier: string;
    description: string;
    startDate: Date;
    endDate: Date;
    version: number;
    hasAttachedFiles: boolean;
    isColdWorkOnly: boolean;
    entrepreneur: string;
    companyNameSnapshot: string;
    isAnonymousPermit: boolean;
    isFinished: boolean;
    renewedByPermitSequenceIdentifier: string;
    departmentName: string;
    departmentAbbreviation: string;
    departmentId: number;
    hasReducedInfo: boolean;
    status: CodeStatus;
    permitName: PermitType;
    permitCategories: PermitCategory[];
    department: CodeDepartment;
    positions: Position[];
    maritimeEventType?: MaritimeEventType;
    contentVersion: number;

    canDelete: boolean;
    canCopy: boolean;
    canCheckout: boolean;
    canRenew: boolean;
};

export default BaseWorkPermitInfo;

export function BaseWorkPermitInfo_normalize(baseWorkPermitInfo: BaseWorkPermitInfo): BaseWorkPermitInfo {
    const normalizedBaseWorkPermitInfo: BaseWorkPermitInfo = {
        companyNameSnapshot: baseWorkPermitInfo.companyNameSnapshot ?? "",
        department: baseWorkPermitInfo.department ?? CodeDepartment.OtherDepartment,
        departmentAbbreviation: baseWorkPermitInfo.departmentAbbreviation ?? "",
        departmentId: baseWorkPermitInfo.departmentId ?? 0,
        departmentName: baseWorkPermitInfo.departmentName ?? "",
        description: baseWorkPermitInfo.description ?? "",
        documentReferenceId: baseWorkPermitInfo.documentReferenceId ?? "",
        endDate: !!baseWorkPermitInfo.endDate ? new Date(baseWorkPermitInfo.endDate) : new Date(),
        entrepreneur: baseWorkPermitInfo.entrepreneur ?? "",
        hasAttachedFiles: baseWorkPermitInfo.hasAttachedFiles ?? false,
        hasReducedInfo: baseWorkPermitInfo.hasReducedInfo ?? false,
        id: baseWorkPermitInfo.id ?? 0,
        isAnonymousPermit: baseWorkPermitInfo.isAnonymousPermit ?? false,
        isColdWorkOnly: baseWorkPermitInfo.isColdWorkOnly ?? false,
        isFinished: baseWorkPermitInfo.isFinished ?? false,
        permitCategories: baseWorkPermitInfo.permitCategories ?? [PermitCategory.Other],
        permitName: baseWorkPermitInfo.permitName ?? PermitType.GeneralDepartmentPermit,
        renewedByPermitSequenceIdentifier: baseWorkPermitInfo.renewedByPermitSequenceIdentifier ?? "",
        sequenceIdentifier: baseWorkPermitInfo.sequenceIdentifier ?? "",
        startDate: !!baseWorkPermitInfo.startDate ? new Date(baseWorkPermitInfo.startDate) : new Date(),
        status: baseWorkPermitInfo.status ?? CodeStatus.Registered,
        version: baseWorkPermitInfo.version ?? 0,
        positions: baseWorkPermitInfo.positions.map(Position_normalize),
        canDelete: baseWorkPermitInfo.canDelete ?? false,
        canCopy: baseWorkPermitInfo.canCopy ?? false,
        canCheckout: baseWorkPermitInfo.canCheckout ?? false,
        canRenew: baseWorkPermitInfo.canRenew ?? false,
        maritimeEventType: baseWorkPermitInfo.maritimeEventType,
        contentVersion: baseWorkPermitInfo.contentVersion ?? 0
    };

    return normalizedBaseWorkPermitInfo;
}
